import Raven from 'raven-js';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { FloatingAlertStore } from 'foundations-components/transitional/components/FloatingAlertList';
import { GET_APP_EMA_STATUS_QUERY } from '../../../__generated__/chirp/com/hubspot/applications/governance/rpc/ApplicationGovernanceAppAuthRpc.dfc.new';
import { useUpdateAppEmaStatusMutation } from '../../../__generated__/chirp/com/hubspot/applications/governance/rpc/ApplicationGovernanceAppAuthRpc.hooks';
import { useApp } from '../../contexts/AppContext';
import { jsx as _jsx } from "react/jsx-runtime";
export function useTurnOffEma() {
  const {
    appId
  } = useApp();
  const [updateEmaStatus, {
    error,
    loading
  }] = useUpdateAppEmaStatusMutation({
    refetchQueries: [{
      query: GET_APP_EMA_STATUS_QUERY,
      variables: {
        appId
      }
    }],
    onError: mutationError => {
      Raven.captureException(mutationError, {
        extra: {
          message: 'Error turning off EMA',
          appId
        }
      });
      FloatingAlertStore.addAlert({
        type: 'danger',
        titleText: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "app-governance-lib.errorBoundary.default.title"
        }),
        message: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "app-governance-lib.advanced.ema.turnOff.error"
        })
      });
    }
  });
  const turnOffEma = () => updateEmaStatus({
    variables: {
      appId,
      emaOptedIn: false
    }
  });
  return {
    turnOffEma,
    error,
    loading
  };
}